import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';
import FieldText from 'components/Field/Text';
import Translate from 'components/Translate';
import { langService } from 'services/LangService';
import { enLang, IProductData } from 'interfaces/IProductData';
import SuggestEmail from './SuggestEmail/index';
import { cartService } from 'services/CartService';
import { enProductType } from 'enums/enProductType';

interface IState extends IStateBase {
  model: ICartModel;
  lang: enLang;
  suggest: boolean;
  cart: IProductData;
}

export default class UserForm extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);
    this.state = { suggest: false, lang: undefined, cart: undefined, model: undefined };
  }

  componentDidMount() {
    this.bindModel(paymentService.getCart());
    this.observeState({ lang: null }, langService.getLang());
    this.observeState({ cart: null }, cartService.getCart());
  }

  componentDidUpdate(props: any) {
    if (this.state.formSubmitted != this.props.formSubmitted) {
      this.setState({ formSubmitted: this.props.formSubmitted });
    }
  }

  autoSuggest = (email: any) => {
    this.setState({ suggest: email.includes('@') });
  }

  autoComplete = (value: any) => {
    const email = `${this.state.model.email.split('@')[0]}${value}`;

    paymentService.setData({ email });
    this.setState({ suggest: false });
  }

  disableSuggest = () => {
    setTimeout(() => this.setState({ suggest: false }), 300);
  }

  setEmail = (email: any) => {
    this.autoSuggest(email);
    paymentService.setData({ email });
  }

  setPhone = (phone: any) => {
    paymentService.setData({ phone });
  }

  setName = (name: any) => {
    paymentService.setData({ name });
  }

  render() {

    if (!this.state.model) {
      return <div />;
    }

    const { model, lang, cart } = this.state;

    return (
      <div className='chk-user-form'>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <FieldText
              id='name'
              label={<Translate term='Nome Completo' />}
              validation='required|name|max:100'
              value={model.name}
              onChange={this.setName}
              inputProps={{
                className: 'theme-input'
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-name'
              }}
            />
          </Grid>

          <Grid item xs={12} sm={cart.config.productType == enProductType.TICKET ? 6 : 12}>
            <div className='tooltip-email-information'>
              {/* <span className='information'>
                Informações da compra serão enviadas neste email.
              </span> */}
              <FieldText
                id='email'
                label={<Translate term='E-mail' />}
                validation='required|email|max:150'
                value={model.email}
                type='email'
                mask='nospace'
                onChange={this.setEmail}
                onBlur={this.disableSuggest}
                inputProps={{
                  className: 'theme-input'
                }}
                InputLabelProps={{
                  className: 'theme-label',
                  id: 'label-email'
                }}
              />
              {this.state.suggest &&
                <SuggestEmail
                  email={model.email.split('@')[1]}
                  autoComplete={this.autoComplete}
                />
              }
            </div>
          </Grid>

          <Grid item xs={12} sm={cart.config.productType == enProductType.TICKET ? 6 : 12}>
            <FieldText
              id='cellphone'
              label={<Translate term='Celular' />}
              validation={lang == enLang.PT_BR ? 'required|min:10|max:11' : 'required|min:3|max:36'}
              value={model.phone}
              mask={lang == enLang.PT_BR ? 'phone' : null}
              type='tel'
              onChange={this.setPhone}
              inputProps={{
                className: 'theme-input'
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-phone'
              }}
            />
          </Grid>
        </Grid>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/MainForm/UserForm/index.tsx